import util from '../ultils/index';

const COMPOSE_SIZE_DEFAULT = { WIDTH: 1088, HEIGHT: 900 };
/**
 *  Open new task compose window
 * @param {object} todoVo pass todoVo.uid for open edit window, otherwise automatically open creation window
 * @param {function} onSave executed after save in new window.
 */

const openTaskWindow = (todoVo, onSave) => {
  window.callback = { onRefreshData: onSave };
  const timeStamp = new Date().getTime();
  const isEditorText = util.isHtmlDocument(todoVo.contents);
  if (!isEditorText) {
    todoVo.contents = util.htmlEscape(todoVo.contents || '');
    todoVo.contents = todoVo.contents.replace(/\s/g, '&nbsp;');
  }
  if (todoVo.uid) {
    util.openCenterWindow(
      `/taskapp/task/detail?taskId=${todoVo.uid}`,
      timeStamp,
      COMPOSE_SIZE_DEFAULT.WIDTH,
      COMPOSE_SIZE_DEFAULT.HEIGHT,
    );
  } else {
    window.detailParams = todoVo;
    util.openCenterWindow(`/taskapp/task/create`, timeStamp, COMPOSE_SIZE_DEFAULT.WIDTH, COMPOSE_SIZE_DEFAULT.HEIGHT);
  }
};
const pimsServices = { openTaskWindow };

export default pimsServices;
